// @ts-strict

import { Component, OnInit, OnChanges, Input, Output, QueryList, ViewChildren, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ITranslatedCountry } from '@app/core/models/core-models';
import { CheckedCountryData, CountryCheckboxComponent } from './country-checkbox/country-checkbox.component';

export interface IOrderedTraslantedCountry extends ITranslatedCountry {
  id: number;
}

export interface CheckedCountries {
  selectedCountries: string[];
  defaultValue: string;
}

@Component({
  selector: 'app-countries-checkbox-list',
  templateUrl: './countries-checkbox-list.component.html',
  styleUrls: ['./countries-checkbox-list.component.scss']
})
export class CountriesCheckboxListComponent implements OnInit, OnChanges {
  @Input() countries: string[] = [];
  @Input() layout?: 'add_campaign' | 'traffic_source' | 'add_campaign';
  @Input() required?: boolean;
  @Input() submitted = false;
  @Input('initValues') initialValues: string[] = [];
  @ViewChildren(CountryCheckboxComponent) private checkboxesComponents?: QueryList<CountryCheckboxComponent>;
  @Output() emitCheckedCountries = new EventEmitter<CheckedCountries>();

  constructor(private translate: TranslateService) {}

  public maxCountries = 10;
  public translatedCountries: IOrderedTraslantedCountry[] = [];
  public search = '';
  checkedValues: string[] = [];
  public defaultValue = 'all';
  public selectedCountries: IOrderedTraslantedCountry[] = [];
  public expandSelectedCountries = false;

  ngOnInit(): void {
    if (this.initialValues.length > 0) {
      for (const value of this.initialValues) {
        const country = this.translatedCountries.find(el => el.originalName === value);

        if (country) {
          this.updateCheckedValues({ checkedCountry: country, isChecked: true });
        }
      }
    }
  }

  ngOnChanges(): void {
    this.countries?.forEach((country, index) => {
      this.translate.get('countries.' + index).subscribe(translatedCountry => {
        this.translatedCountries.push({ id: index, originalName: country, translatedName: translatedCountry.name });
      });
    });
  }

  public isCountryVisible(index: number): boolean {
    if (!this.expandSelectedCountries) {
      return index > this.maxCountries - 1 ? true : false;
    } else {
      return false;
    }
  }

  public expandSelectedCountriesList(): void {
    this.expandSelectedCountries = !this.expandSelectedCountries;
  }

  public updateUncheckedValues($event: CheckedCountryData): void {
    this.selectedCountries = this.selectedCountries.filter(el => el.originalName !== $event.checkedCountry.originalName);
    this.translatedCountries.push($event.checkedCountry);
    this.sortArrayByIndex(this.translatedCountries);
    this.checkedValues = this.checkedValues.filter(value => value !== $event.checkedCountry.originalName);
    this.emitCheckedCountries.emit({ selectedCountries: this.checkedValues, defaultValue: this.defaultValue });
  }

  public updateCheckedValues({ checkedCountry, isChecked }: CheckedCountryData): void {
    if (checkedCountry.originalName !== 'all') {
      if (isChecked) {
        this.checkedValues.push(checkedCountry.originalName);
        this.selectedCountries.push(checkedCountry);
        // this.sortArrayByIndex(this.selectedCountries);
        this.translatedCountries = this.translatedCountries.filter(el => el.originalName !== checkedCountry.originalName);
      } else {
        this.checkedValues = this.checkedValues.filter(value => value !== checkedCountry.originalName);
      }
    } else {
      this.checkedValues = [];
      this.checkboxesComponents?.forEach(component => (component.checkedCountry = false));
    }
    if (this.checkedValues.length > 0 && checkedCountry.originalName !== 'all') {
      this.defaultValue = 'none';
    } else {
      this.defaultValue = 'all';
    }
    this.emitCheckedCountries.emit({ selectedCountries: this.checkedValues, defaultValue: this.defaultValue });
  }

  private sortArrayByIndex(countries: IOrderedTraslantedCountry[]): void {
    countries.sort((a, b) => a.id - b.id);
  }
}
